import type { Coords } from '@/types/coords';
import { LocaleSeparators } from '@/types/utils';

export function padNumber(num: number) {
  return `${num}`.length === 1 ? `0${num}` : `${num}`;
}

export function isNumber(val: any): val is number {
  return typeof val === 'number';
}

export function parseLocaleInt(val: string) {
  // TODO: Rounding?
  return parseInt(parseLocaleNumber(val).toString());
}

export function getAverage(...numbers: number[]): number {
  // Calculate the average of an array of numbers
  return numbers.reduce((acc, val) => acc + val, 0) / numbers.length;
}

export function getDistance([x1, y1]: Coords, [x2, y2]: Coords): number {
  // Gets the distance between two 2D coordinates
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
}

export function getCenter([x1, y1]: Coords, [x2, y2]: Coords): Coords {
  // Gets the center point between two 2D coordinates
  return [getAverage(x1, x2), getAverage(y1, y2)];
}

export function getLocaleSeparators(
  locale = navigator.language
): LocaleSeparators {
  const formatter = new Intl.NumberFormat(locale);
  const parts = formatter.formatToParts(12345.67); // Example number to get locale-specific separators
  return {
    group: parts.find((part) => part.type === 'group')?.value || ',',
    decimal: parts.find((part) => part.type === 'decimal')?.value || '.',
  };
}

export function parseLocaleNumber(
  price: string,
  localeSeparators?: LocaleSeparators
): number {
  let { group, decimal } = localeSeparators || getLocaleSeparators();
  // Replace locale-specific separators with standard ones
  const normalizedPrice = price
    .replace(new RegExp(`\\${group}`, 'g'), '')
    .replace(new RegExp(`\\${decimal}`), '.');

  return parseFloat(normalizedPrice);
}
